import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Tooltip } from '@mui/material';

import TablePagination from '@mui/material/TablePagination';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData2, activateData, fetchData1 } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Info as InfoIcon,

} from '@mui/icons-material';

//import '../../styles.css';
function MemberIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    //const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const { isAuthenticated, clubId, branchId, roleName, permissions, token, logout, username } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [branchid, setBranchid] = useState(0);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        // inputRef.current.focus();
    }, [isAuthenticated, clubId, branchId, roleName, token, logout, username]);

    // useEffect(() => {
    //     if (searchTerm.trim() == '') {
    //         setFilteredData(data);
    //     } else {
    //         const filtered = data.filter(member => member.firstName.toLowerCase().includes(searchTerm.toLowerCase()));
    //         setFilteredData(filtered);
    //     }
    // }, [data, searchTerm]);
    useEffect(() => {

        fetchtableData();

    }, []);

    const fetchtableData = async () => {
        try {
            // Construct params1 and params2
            if (roleName === "SuperAdmin" || roleName === "CompanyAdmin") {
                const branchid = 0;
                setBranchid(branchid);
                const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);


                if (response.responseCode === '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            } else {
                setBranchid(branchId);

                // const response = await fetchData1('MemberApi', params1, params2, token);
                const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);


                if (response.responseCode === '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            }
        } catch (error) {
            console.error('Error fetching table data:', error);
        }
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);

    const [showSearchInput, setShowSearchInput] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );



    const handleDelete = async () => {
        deleteData2('MemberApi', deleteMember, 1, token) // Removed extra `/`
            .then((response) => {
                fetchtableData();
                setDeleteMember(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (memberId) => {
        activateData('MemberApi', `${memberId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (memberId) => {
        setDeleteMember(memberId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteMember(null);
        setConfirmDialogOpen(false);
    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page when changing rows per page
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                {/* <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    MEMBER</h6>


                <div className="button-container-1">

                    <Button
                        component={Link}
                        to="/MemberCreate"
                        className="linkcolor"
                        style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
                    >
                        <AddIcon /> CREATE
                    </Button>
                </div> */}
                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}>MEMBER</h6>
                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '250px' : '140px',
                        height: '30px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginLeft: '10px'
                    }}
                />

                <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title="Create Member"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#0e728c',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                },
                            },
                        }}
                    >
                        <Button
                            component={Link}
                            to="/MemberCreate"
                            className="linkcolor"
                            style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}
                        >
                            CREATE
                        </Button>
                    </Tooltip>
                </div>


            </div>


            <div className='w-full mb-2 flex' style={{ maxHeight: '570px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}
                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>First Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Last Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Email</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Phone</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Position</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#cef1fa' }}>

                            {paginatedData.map((member, index) => (
                                <TableRow
                                    key={member.id}
                                    className={member.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd',
                                        // Alternate row background colors
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.firstName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.lastName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.email}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.phoneNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.usertypes}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', textAlign: 'center' }}>

                                        <Link to={`/MemberEdit/${member.id}`}>
                                            <Tooltip title="Edit Members">

                                                <IconButton>
                                                    <EditIcon style={{ fontsize: '20px', color: 'blue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>

                                        <Link to={`/UserDescription/${member.id}`}>
                                            <Tooltip title="Set User Roles">
                                                <IconButton>
                                                    <InfoIcon style={{ color: 'darkgoldenrod' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>
                                        <Tooltip title="Delete Members">
                                            <IconButton onClick={() => (member.isActive ? openConfirmDialog(member.id) : handleActivate(member.id))}>
                                                {member.isActive ? <DeleteIcon style={{ fontsize: '20px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '20px' }} />}
                                            </IconButton>
                                        </Tooltip>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 250, 350]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            '& .MuiTablePagination-toolbar': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'nowrap', // Ensures everything stays in one line
                                minHeight: '40px', // Keeps a proper height
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: 0, // Fixes label misalignment
                            },
                            '& .MuiTablePagination-displayedRows': {
                                marginBottom: 0, // Fixes row count misalignment
                            },
                        }}
                    />
                </TableContainer>
            </div>
        </div>
    );
}

export default MemberIndex;




